export const config = {
    apiKey: "AIzaSyAlIZjF7-B3fA1IVgqu3zRUShbmuOi2GSA",
    authDomain: "tapmenow-web.firebaseapp.com",
    databaseURL: "https://tapmenow-web.firebaseio.com",
    projectId: "tapmenow-web",
    storageBucket: "tapmenow-web.appspot.com",
    messagingSenderId: "682226549092"
};


// WEBPACK FOOTER //
// ./src/push/firebaseConfig.js